import { Entry } from 'contentful';
import { ApplicationSettings } from '../../models/settings';
import IShouldReturnEntity from '../../api-clients/IShouldReturnEntity';
import IReason from '../../api-clients/IReason';

export default abstract class BaseComponentModel {
  type: string;
  isValid: boolean;
  appSettings: ApplicationSettings;
  parentPage: string;
  exclusionReasons: IReason[] = [];

  constructor(type: string, appSettings: ApplicationSettings) {
    this.type = type;
    this.appSettings = appSettings;
    this.isValid = true;
  }

  protected abstract shouldReturnEntity(entry: Entry<any>): IShouldReturnEntity;
}
